module.exports = __webpack_public_path__ + "img/button-down.38d64987.svg";